import React, { useLayoutEffect } from 'react';
import Img from 'react-image';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { useImageSize } from '../../../hooks/useImageSize';
import { gaSubSectionAccess } from '../../../services/analitics';
import { Message } from '../../commons/message/message';
import './index.scss';

export const PagePreview = ({ pageProps }) => {
  const { path, section, floor, title, picture, description, info } = pageProps;
  const { storeId, userLocale } = useSelector((state) => state.config);
  const { floorKey, sectionKey } = useSelector((state) => state.location);
  const history = useHistory();
  const { urlResized } = useImageSize(picture);
  useLayoutEffect(() => {
    document.getElementsByClassName('canvas')[0].scrollTo(0, 0);
    sessionStorage.setItem('gaSection', 'root');
  }, []);
  const onMapView = () => {
    const mapviewPath = `${path}/mapview`;
    const url = `${window.location.href}/mapview`;
    gaSubSectionAccess(storeId, userLocale, floorKey, sectionKey, url);
    history.push(mapviewPath);
  };

  return (
    <>
      <div className={'page-view__wrapper'}>
        <div className={'page-view__header'}>
          <div className={'breadcrumbs zds-body-xs'}>
            <Message tag="span" id={section} />
            <Message tag="span" id={floor} />
          </div>
          <Message className={'zds-heading-m-highlight'} id={title} tag="p" />
        </div>
        <div className={'page-view__info'}>
          <Message id={info} tag="p" className={'zds-paragraph-m'} />
        </div>
        <Img className={'page-view__picture'} src={urlResized} alt="top-img" />
        <div className={'page-view__description'}>
          <Message
            id={description.content}
            tag="p"
            className={'zds-paragraph-m'}
          />
        </div>
        <div className={'view-map__action'}>
          <hr />
          <button onClick={onMapView} className={'zds-body-l-highlight'}>
            <Message id="store.floorMap.btn.viewMore" />
          </button>
        </div>
      </div>
    </>
  );
};
